import { Link } from "react-router-dom";
import { categories } from "@/mocks/videos";

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14" id="video-categories" aria-label="视频分类导航">
      <div className="text-center mb-8">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-900" style={{ fontFamily: "var(--font-heading)" }}>
          视频分类
        </h2>
        <p className="text-sm text-foreground-500 mt-2">八大分类，总有一款适合你</p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3 md:gap-4">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group flex flex-col items-center gap-2 p-4 md:p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-200 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer"
          >
            <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-accent-100 flex items-center justify-center group-hover:bg-primary-100 transition-colors">
              <i className={`${cat.icon} text-lg md:text-xl text-accent-600 group-hover:text-primary-600 transition-colors`}></i>
            </div>
            <span className="text-xs md:text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
              {cat.name}
            </span>
            <span className="text-xs text-foreground-400 hidden sm:block text-center leading-tight">
              {cat.description}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}